'use client';
import React, { useEffect, useState } from 'react';
import style from './style.module.css';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const ButtonBackToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
      return;
    }
    setVisible(false);
  };

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
  }, []);

  return (
    <>
      {visible && (
        <button
          className={`${style.containerButtonBackToTop} `}
          onClick={handleBackToTop}>
          <ArrowUpwardIcon />
        </button>
      )}
    </>
  );
};

export default ButtonBackToTop;
